module.exports = __webpack_public_path__ + "img/folder-open.e31c5104.svg";